// 결제 공용 상수 — shared/external(kcp·toss) 등 최하위 레이어가 소비하므로 shared에 위치.
// (구 features/payment/lib/payment.ts — 역참조 해소로 이동)

export const PAYMENT_ENVIRONMENT = {
  PC: 'pc',
  MOBILE: 'mobile',
} as const

export const PAYMENT_PG = {
  KCP: 'kcp',
  TOSS_PAYMENTS: 'tosspayments',
} as const

export const SELECT_PAYMENT_METHODS = {
  BANK: 'bank',
  CARD: 'card',
  TOSS_PAY: 'tosspay',
  KAKAO_PAY: 'kakaopay',
  NAVER_PAY: 'naverpay',
  /** 무통장입금(가상계좌). KCP 결제창에서 계좌를 발급받고, 입금은 나중에 한다 */
  VBANK: 'vbank',
} as const

export const PAYMENT_TEXT = {
  CANCEL_PAYMENT: '결제를 취소했어요',
}

/**
 * PG 결제가 끝나고 돌아올 수 있는 화면들(접두어 없는 경로).
 *
 * @description
 * 웹예약·타이어가 각자 자기 경로를 들고 있으면 BFF 가 어디까지 열어 줄지 알 수 없다.
 * 한 곳에 모아 두고 BFF(`/api/payment/kcp/mobile/callback`)가 이 목록으로 검사한다 —
 * 돌아갈 주소에는 결제 결과 파라미터가 그대로 붙어 가므로 결제 화면만 연다.
 */
export const PAYMENT_RETURN_ROUTES = {
  RESERVATION_CALLBACK: (pg: string) => `/reservation/payment/callback/${pg}`,
  RESERVATION_FAIL: '/reservation/payment/fail',
  TIRE_CALLBACK: (pg: string) => `/tire-reservation/payment/callback/${pg}`,
  TIRE_FAIL: '/tire-reservation/payment/fail',
} as const

/** 실패 화면 주소에 어디서 멎었는지 남기는 쿼리 키. 데이터독 결제 실패 알림이 이 값으로 나눈다 */
export const PAYMENT_FAIL_REASON_QUERY_KEY = 'reason'

export const PAYMENT_FAIL_REASON = {
  NO_RESULT: 'no-result',
  CALLBACK_ERROR: 'callback-error',
  USER_CANCEL: 'user-cancel',
  PG_FAIL: 'pg-fail',
  APPROVE_FAILED: 'approve-failed',
  INVALID_CALLBACK: 'invalid-callback',
} as const
